import React, { useState, useEffect , useContext} from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory from 'react-bootstrap-table2-editor';
import Button from 'react-bootstrap/Button';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import NumberFormat from 'react-number-format';
import { isNullOrUndefined } from 'util';
import { LabelText } from '../../../components/Language';
import {LanguageContext} from '../../../containers/Language/LanguageProvider';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import config from '../../../common/const/config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSyncAlt, faHourglassHalf, faCheckSquare, faWindowClose, faTimes, faAngleDoubleDown } from '@fortawesome/free-solid-svg-icons';
import { parse } from 'date-fns';
import { changeRequestStatuses, checkChangeRequestDataChanged } from '../../../common/const/changeRequestHelper';
import { isEmptyObject, formattedRevenueAmountValues, formattedSoldTicketValue } from '../../../common/utility/utility';
import CustomOverlayTrigger from '../../../hoc/CustomOverlayTrigger';
import {changeRequestTooltip, hiddenTooltip} from '../../../components/UI/Tooltip/Tooltip';
import {SubmitSelectionFooter} from '../../../components/UI/SubmitSelectionFooter/SubmitSelectionFooter';
import {RemainingCharacters} from '../../../components/UI/RemainingCharacters/RemainingCharacters';
import './index.css';
import { RevenueCalendarContext } from '../../context/RevenueCalendarProvider';


export default function RevenueDetails(props) {

    const [revenueData, setData] = useState([]);
    const [error, setError] = useState("");
    const [expendedRowList, setExpendedRowList] = useState([]);
    const [inprocessCRList, setInprocessCRList] = useState([]);
    const [approveCRList, setApproveCRList] = useState([]);
    const [declineCRList, setDeclineCRList] = useState([]);
    const [lockedContractList, setLockedContractList] = useState([]);
    const [inprocessUnlockCRList, setInprocessUnlockCRList] = useState([]);
    const languageContext = useContext(LanguageContext);
    const { rawDateError } = useContext(RevenueCalendarContext);
    const maxvalue = config.maxfieldvalue;

    const submitTooltip = (
        <Tooltip id="submitButton">
          <LabelText tid="submit" />
        </Tooltip>
    );

    const lockedSubmitTooltip = (
        <Tooltip id="lockedSubmitButton">
          <LabelText tid="submitdisabled" />
        </Tooltip>
    );

    const futureDateSubmitTooltip = (
        <Tooltip id="futuredateSubmitButton" style={{whiteSpace: "pre-wrap"}}>
          <LabelText tid="futuredateDisableSubmit" />
        </Tooltip>
    );
    
    function InitialFormatRevenueData(initialData) {
        if (initialData && initialData.length > 0) {
            initialData = initialData.map(d => {

                return {
                    ...d,
                    revenueAmount: formattedRevenueAmountValues(d),
                    soldTicket: formattedSoldTicketValue(d),
                    isShopOpen: d.isShopOpen,
                    remarksOptionValues : getRemarksFilterValue(d.isShopOpen),
                    remarksId : d.remarksId,
                    remarksCode : d.remarksCode,
                    isSelectionAllowed: !isCheckboxSelectionAllowed(d),
                    isChecked: d.isSelectionAllowed && d.isChecked ? d.isChecked : false,
                    isFutureDateAndShopOpenYes: IsDisablingSubmitForFutureDateSelection(d),
                    changeRequest: d.changeRequest && !isEmptyObject(d.changeRequest) ? {
                        ...d.changeRequest,
                        revenueAmount: formattedRevenueAmountValues(d.changeRequest),
                        soldTicket: formattedSoldTicketValue(d.changeRequest)
                    }: null,
                    crRemarksOptionValues: d.changeRequest && !isEmptyObject(d.changeRequest) ? getRemarksFilterValue(d.changeRequest.isShopOpen) : null,
                    tax_0_ErrorMessage: d.tax_0_ErrorMessage,
                    tax_6_ErrorMessage: d.tax_6_ErrorMessage,
                    tax_12_ErrorMessage: d.tax_12_ErrorMessage,
                    tax_21_ErrorMessage: d.tax_21_ErrorMessage,
                    soldTicket_ErrorMessage: d.soldTicket_ErrorMessage,
                    isShopOpen_ErrorMessage: d.isShopOpen_ErrorMessage,
                    remarks_ErrorMessage: d.remarks_ErrorMessage,
                    businessPartnerRemarks_ErrorMessage: d.businessPartnerRemarks_ErrorMessage
                }
            });
        }

        return initialData;
    }

    const IsDisablingSubmitForFutureDateSelection = (row) => {
        if (row.isShopOpen === "Yes")
            {
                const revDate = parse(props.revenueDate, "dd/MM/yyyy", new Date());
                const currDate = new Date();
                return revDate && revDate > currDate;
            }

        return false;
    }

    const isHeaderSelectionAllow = (revData) => {
        const noOfUnsubmittedContracts =  revData.some(d=>!d.isSubmitted && d.isMonthlySubmitted) ? 
                                            revData.filter(d=>!d.isSubmitted && d.isMonthlySubmitted).length : 0;
        return noOfUnsubmittedContracts && noOfUnsubmittedContracts > 0 ? noOfUnsubmittedContracts : 0;
    }

    const isCheckboxSelectionAllowed = (row)=> {
        let isError = false;
        if(!row.isSubmitted && row.isMonthlySubmitted) {
            if(checkIfNullOrUndefined(row.revenueAmount.tax_0))
            {
                isError = true;
            }
            else if(checkIfNullOrUndefined(row.revenueAmount.tax_6))
            {
                isError = true;
            }
            else if(checkIfNullOrUndefined(row.revenueAmount.tax_12))
            {
                isError = true;
            }
            else if(checkIfNullOrUndefined(row.revenueAmount.tax_21))
            {
                isError = true;
            }
            else if(checkIfNullOrUndefined(row.soldTicket))
            {
                isError = true;
            }
            else if(row.isShopOpen === "No") {
                isError = checkIsShopOpenStatusCorrect(row);
            }
            else if ((row.tax_0_ErrorMessage && row.tax_0_ErrorMessage.trim() !== "") ||
                (row.tax_6_ErrorMessage && row.tax_6_ErrorMessage.trim() !== "") ||
                (row.tax_12_ErrorMessage && row.tax_12_ErrorMessage.trim() !== "") ||
                (row.tax_21_ErrorMessage && row.tax_21_ErrorMessage.trim() !== "") ||
                (row.soldTicket_ErrorMessage && row.soldTicket_ErrorMessage.trim() !== "") ||
                (row.isShopOpen_ErrorMessage && row.isShopOpen_ErrorMessage.trim() !== "") ||
                (row.remarks_ErrorMessage && row.remarks_ErrorMessage.trim() !== "")) {
                isError = true;
            }
        }
        return isError;
    }

    const handleOnSelectAll = (ev) => {
        let isSoldTicketError = false;
        const isPartiallyChecked = props.revenue && props.revenue.length > 0  && props.revenue.some(d=>d.isChecked);
        props.revenue && props.revenue.length > 0  && props.revenue.map(d=>{
            if(!d.isSubmitted && d.isMonthlySubmitted) {
                if(d.isSelectionAllowed) {
                    d.isChecked = !isPartiallyChecked && ev.target.checked;
                    props.setRevenueData(d.index, d.contractCode, d);
                } else if(d.isShopOpen === "Yes") {
                    if(checkAreInValidValuesForShopOpenYes(d, true, true)) {
                        isSoldTicketError=true;
                    }
                }
            }
        });

        if(ev.target.checked && isSoldTicketError) {
            //Write code to show popup
        }
    }

    function selectAllFormatter(column, colIndex) {
        const revData = props.revenue && props.revenue.length > 0 ? props.revenue : [];
        const unSubmittedCount= isHeaderSelectionAllow(revData);
        let checkedCount = 0;
        
        checkedCount=revData.filter(d=>!d.isSubmitted && d.isMonthlySubmitted &&
                                    d.isSelectionAllowed && d.isChecked).length;


        let isSelectAllChecked = false;
        let isPartiallyChecked = false;
        if(unSubmittedCount && checkedCount) {
            if(unSubmittedCount === checkedCount) {
                isSelectAllChecked = true;
            } else if(unSubmittedCount > checkedCount) {
                isPartiallyChecked = true;
            }
        }

        return  unSubmittedCount ?  
            (
            <div>
                <div style={{ float: "left"}}>
                    <input id={"checkboxAll"} type="checkbox" 
                    ref={ (input) => {
                        if (input) { 
                            input.indeterminate = isSelectAllChecked ? false : isPartiallyChecked; 
                        }             
                    } }
                    checked={isSelectAllChecked} onChange={(ev)=>handleOnSelectAll(ev)} /></div>
                <div style={{ textAlign: "center", paddingLeft: "1.5vw" }}><span>{column.text}</span></div>
            </div>
            )
        :  (<span>{column.text}</span>)
    }

    const handleOnContractSelect = (ev, row, extraData) => {
        if(ev.target.checked && row.isShopOpen === "Yes" && checkAreInValidValuesForShopOpenYes(row, true)) {
            row.isChecked = false;
            row.isSelectionAllowed = false;
        } else {
            row.isChecked = ev.target.checked;
        }
        props.setRevenueData(row.index, row.contractCode, row);
    }

    function selectCheckboxFormatter(row) {
        return  (<input id={"checkbox_"+row.index} type="checkbox" style={{marginRight: "0.2vw"}}
                disabled={!row.isSelectionAllowed} checked={row.isSelectionAllowed && row.isChecked}
                onChange={(ev)=>handleOnContractSelect(ev, row)} />)
    } 

    const checkFieldValidation = (d, fieldLevelError) => {
        if (d.tax_0_ErrorMessage && d.tax_0_ErrorMessage.trim() !== "" )
                    fieldLevelError = d.tax_0_ErrorMessage;
        else if (fieldLevelError === "" && d.tax_6_ErrorMessage && d.tax_6_ErrorMessage.trim() !== "" )
                    fieldLevelError = d.tax_6_ErrorMessage;
        else if (fieldLevelError === "" && d.tax_12_ErrorMessage && d.tax_12_ErrorMessage.trim() !== "" )
                    fieldLevelError = d.tax_12_ErrorMessage;
        else if (fieldLevelError === "" && d.tax_21_ErrorMessage && d.tax_21_ErrorMessage.trim() !== "" )
                    fieldLevelError = d.tax_21_ErrorMessage;
        else if (fieldLevelError === "" && d.soldTicket_ErrorMessage && d.soldTicket_ErrorMessage.trim() !== "") {
                    fieldLevelError = d.soldTicket_ErrorMessage;
        } else if(fieldLevelError === "" && d.isShopOpen_ErrorMessage && d.isShopOpen_ErrorMessage.trim()!==""){
            fieldLevelError = d.isShopOpen_ErrorMessage;
        }
		else{
            fieldLevelError = "";
        }
        return fieldLevelError;
    }

    function applyFieldLevelValidation(row, isInvalidValue, fieldExceedingError, areInValidValuesForShopOpenYes) {
        revenueData[row.index] = row;
        let fieldLevelError = "";

        if(fieldExceedingError !== "")
        {
			row.isChecked = false;
            fieldLevelError = fieldExceedingError;
            props.setRevenueData(row.index, row.contractCode, row);
        }
        else
        {
            revenueData.map((d, index) => {
                
                fieldLevelError = checkFieldValidation(d, fieldLevelError);

                fieldLevelError = isInvalidValueExistsInRow(d, "fieldexceeding") ? "fieldexceeding" : fieldLevelError;

                if(index === row.index && isInvalidValue === false)
                {
                    if(fieldLevelError === 'mandatory')  {
                        fieldLevelError = "";
                    }
                    props.setRevenueData(row.index, row.contractCode, row);
                }
            });
        }

        if(!areInValidValuesForShopOpenYes || fieldLevelError ==="") {
            setError(fieldLevelError);
        }

        if (fieldLevelError.trim() === "") {
            props.setRevenueData(row.index, row.contractCode, row);
        }
    }

    const getContractIdsByStatus = (revData, status, columnName) => {
        return revData.filter(d=>d.isSubmitted && d.changeRequest && 
                        d.changeRequest.changeRequestStatus === status)
                        .map(row => row.contractId);
    }

    const getLockedContractList = (revData, status, isCrAllowed) => {
        return revData.filter(d=>!d.isSubmitted && !d.isMonthlySubmitted && 
                                        d.isUnblockChangeRequestAllowed === isCrAllowed && d.unblockChangeRequest && 
                                        d.unblockChangeRequest.changeRequestStatus === status)
                                .map(row => row.contractId);
    }

    useEffect(() => {
        let changedData = []
        if (props.revenue && props.revenue.length > 0) {
            changedData = InitialFormatRevenueData(props.revenue);
        }
        setData(changedData);
        setLockedContractList(getLockedContractList(changedData, changeRequestStatuses.Unsubmitted.id, true));
        setInprocessUnlockCRList(getLockedContractList(changedData, changeRequestStatuses.Inprogress.id, false));
        setInprocessCRList(getContractIdsByStatus(changedData, changeRequestStatuses.Inprogress.id));
        setApproveCRList(getContractIdsByStatus(changedData, changeRequestStatuses.Approve.id));
        setDeclineCRList(getContractIdsByStatus(changedData, changeRequestStatuses.Decline.id));
    }, [props.revenue]);

    const setErrorAttributes = (e, row, columnName, errorType) => {
        const value = e.target.value;
        e.target.style.border = "0.1vw solid red";
        if (columnName !== "soldTicket")
        {
            row.revenueAmount[columnName] = value;
        }
        else
        {
            row[columnName] = value;
        }
        row[columnName + "_ErrorMessage"] = errorType;
        applyFieldLevelValidation(row, true , errorType);
    }

    const isMoreThanMaxValue = (maxValueField) => {
        return maxValueField && Number(maxValueField) >= 0 && convertToNumber(maxValueField) > maxvalue ;
    }

    const isInvalidDecimal = (value) => {
        if(value && Number(value) >= 0) {
            let decimalValue = value.split(",");
            return decimalValue.length > 1 && decimalValue[1].length !== 2 ? true : false;
        }
        return false;
    }

    function checkDecimalValue(e, row, columnName) {
        const errorMsg_Field_Suffix = "_ErrorMessage"
        const value = e.target.value;
        let areInValidValuesForShopOpenYes = false;
        row[columnName + errorMsg_Field_Suffix] = "";
        row.isShopOpen_ErrorMessage = "";
        if (value !== null && value.trim() !== "")
        {
            let decimalValue = value.split(",");
            if (decimalValue.length > 1 && decimalValue[1].length !== 2 ) {
                setErrorAttributes(e, row, columnName, "validdata");
                return false;
            }
            else if(convertToNumber(e.target.value) > maxvalue)
            {
                setErrorAttributes(e, row, columnName, "fieldexceeding");
                return false;
            }
            else {
                if (columnName !== "soldTicket") {
                    let vatValue = value;
                    if (decimalValue.length === 1)
                        vatValue = vatValue + ",00";
                    row.revenueAmount[columnName] = vatValue;
                }
                else {
                    row.soldTicket = value;
                }

                e.target.style.border = "0.2vw solid rgb(192,192,192)";
            }
        }
        else
        {
            columnName === "soldTicket" ? row.soldTicket = value : row.revenueAmount[columnName]= value;
        }

        row[columnName + errorMsg_Field_Suffix] = "";

        if(!checkIsShopOpenStatusCorrect(row)) {
            areInValidValuesForShopOpenYes = checkAreInValidValuesForShopOpenYes(row, false);
        }

        applyFieldLevelValidation(row, areInValidValuesForShopOpenYes, "", areInValidValuesForShopOpenYes);

        return true;
    }

    const isInvalidValueExistsInRow = (rowToCheck, checkType) => {
        if(checkType === "fieldexceeding")
        {
            return isMoreThanMaxValue(rowToCheck.revenueAmount.tax_0) ||
            isMoreThanMaxValue(rowToCheck.revenueAmount.tax_6) ||
            isMoreThanMaxValue(rowToCheck.revenueAmount.tax_12) ||
            isMoreThanMaxValue(rowToCheck.revenueAmount.tax_21) ||
            isMoreThanMaxValue(rowToCheck.soldTicket)
        }
        else if(checkType === "validdata")
        {
            return isInvalidDecimal(rowToCheck.revenueAmount.tax_0) ||
            isInvalidDecimal(rowToCheck.revenueAmount.tax_6) ||
            isInvalidDecimal(rowToCheck.revenueAmount.tax_12) ||
            isInvalidDecimal(rowToCheck.revenueAmount.tax_21) ||
            isInvalidDecimal(rowToCheck.soldTicket)
        }
        else
        {
            return isMoreThanMaxValue(rowToCheck.revenueAmount.tax_0) || isInvalidDecimal(rowToCheck.revenueAmount.tax_0) ||
            isMoreThanMaxValue(rowToCheck.revenueAmount.tax_6) || isInvalidDecimal(rowToCheck.revenueAmount.tax_6) ||
            isMoreThanMaxValue(rowToCheck.revenueAmount.tax_12) || isInvalidDecimal(rowToCheck.revenueAmount.tax_12) ||
            isMoreThanMaxValue(rowToCheck.revenueAmount.tax_21) || isInvalidDecimal(rowToCheck.revenueAmount.tax_21) ||
            isMoreThanMaxValue(rowToCheck.soldTicket) || isInvalidDecimal(rowToCheck.soldTicket)
        }
    }

    const onInputBox_ChangeHandler = (e, row, columnName) => {
        checkDecimalValue(e, row, columnName);
    }

    const setNumericFieldValuesAndError = (value, row) => {
        row.revenueAmount.tax_0 = value;
        row.revenueAmount.tax_6 = value;
        row.revenueAmount.tax_12 = value;
        row.revenueAmount.tax_21= value;
        row.soldTicket = row.isShopOpen === 'No' ? "0" : value;

        row.tax_0_ErrorMessage="";
        row.tax_6_ErrorMessage="";
        row.tax_12_ErrorMessage="";
        row.tax_21_ErrorMessage="";
        row.soldTicket_ErrorMessage="";
    }

    const onShopOpenDropdown_ChangeHandler = (e, row, extraData, isNewOrCr) => {
            row.isShopOpen = e.target.value;
            row.remarksOptionValues = getRemarksFilterValue(row.isShopOpen)
            row.remarksId = row.remarksOptionValues[0].codeValueId
            const rmksCode = row.remarksOptionValues.filter(x => x.codeValueCategory.toLowerCase() === e.target.value.toLowerCase())
            row.remarksCode = rmksCode[0].codeValue;
            if (row.isShopOpen === 'No')
            {
                setNumericFieldValuesAndError("0,00", row);
                setError(null);
                row.isShopOpen_ErrorMessage = "";
                row.remarks_ErrorMessage = "";
            } else if(IsDisablingSubmitForFutureDateSelection(row)) {
                row.isShopOpen_ErrorMessage="shopOpenStatusFuturedate";
                setNumericFieldValuesAndError("", row);
                setError("shopOpenStatusFuturedate");
                clearRemarksErrorMessage(row);
            } else {
                setError(null);
                row.isShopOpen_ErrorMessage = "";
                row.remarks_ErrorMessage = "";
            }
            if(!checkAreInValidValuesForShopOpenYes(row, false)) {
                if(!isCheckboxSelectionAllowed(row)) {
                    row.isSelectionAllowed=true;
                }
            }
            props.setRevenueData(row.index, row.contractCode, row);
    }

    const onRemarksDropdown_ChangeHandler = (e, row) => {
        const rmksCode = row.remarksOptionValues.filter(x => x.codeValueId === +e.target.value)
        row.remarksCode = rmksCode[0].codeValue;
        row.remarksId = rmksCode[0].codeValueId;
        row.remarks_ErrorMessage = "";
        props.setRevenueData(row.index, row.contractCode, row);
    }

    const checkIfNullOrUndefined = (fieldValue) => {
        return isNullOrUndefined(fieldValue) || fieldValue === "";
    }

    const checkIfAmountIsZero = (amountValue) => {
        return amountValue!=="" && amountValue !== "0" && amountValue !== "0,00"
    }

    const convertToNumber = (value) => {
        return Number(value.replace(/\./g, "").replace(/\,/g, "."))
    }

    const setBorder = (columnName, rowIndex, className, isAdd) => {
        const id= "#"+columnName+"_"+rowIndex;
        let idSelector=document.querySelector(id);
        if(idSelector && idSelector.classList) {
            isAdd ? idSelector.classList.add(className) : idSelector.classList.remove(className)
        }
    }

    const checkIsShopOpenStatusCorrect = (row) => {
        if (row.isShopOpen === "No" && (checkIfAmountIsZero(row.revenueAmount.tax_0) || checkIfAmountIsZero(row.revenueAmount.tax_6) ||
            checkIfAmountIsZero(row.revenueAmount.tax_12) || checkIfAmountIsZero(row.revenueAmount.tax_21) ||
            (row.soldTicket !== "0" && row.soldTicket !== 0))) {
                setError("shop_openstatus");
                row.isShopOpen_ErrorMessage="shop_openstatus";
                row.isChecked=false;
                row.isSelectionAllowed=false;
                setBorder("isShopOpen", row.index, "highlight-field", true);
                return true;
        }
        else {
            setBorder("isShopOpen", row.index, "highlight-field", false);
            row.isShopOpen_ErrorMessage="";
            if(error && error.trim() === "shop_openstatus") {
                setError(null);
            }
            return false;
        }
    }

    const checkAreInValidValuesForShopOpenYes = (row, isSubmit, isSelectAll) => {
        let isError = false;
        let errMsg = ""
        if (row.isShopOpen === "Yes" && (checkIfAmountIsZero(row.revenueAmount.tax_0) || checkIfAmountIsZero(row.revenueAmount.tax_6) ||
                checkIfAmountIsZero(row.revenueAmount.tax_12) || checkIfAmountIsZero(row.revenueAmount.tax_21)) &&
                (row.soldTicket === "0" || row.soldTicket === 0)) {
            isError = true;
            errMsg="soldticketvalidation1";
        } else if (row.isShopOpen === "Yes" && (!checkIfNullOrUndefined(row.revenueAmount.tax_0) &&
                    !checkIfNullOrUndefined(row.revenueAmount.tax_6) &&
                    !checkIfNullOrUndefined(row.revenueAmount.tax_12) &&
                    !checkIfNullOrUndefined(row.revenueAmount.tax_21) &&
                    !checkIfAmountIsZero(row.revenueAmount.tax_0) &&
                    !checkIfAmountIsZero(row.revenueAmount.tax_6) &&
                    !checkIfAmountIsZero(row.revenueAmount.tax_12) &&
                    !checkIfAmountIsZero(row.revenueAmount.tax_21)) &&
                    (row.soldTicket !== "0" && row.soldTicket !== 0)) {
            errMsg="soldticketvalidation2";
            isError = true;
        } else if(isInvalidValueExistsInRow(row)) {
            if(row.tax_0_ErrorMessage !== "") {
                setError(row.tax_0_ErrorMessage);   
            } else  if(row.tax_6_ErrorMessage !== "") {
                setError(row.tax_6_ErrorMessage);   
            } else  if(row.tax_12_ErrorMessage !== "") {
                setError(row.tax_12_ErrorMessage);   
            } else  if(row.tax_21_ErrorMessage !== "") {
                setError(row.tax_21_ErrorMessage);   
            } else  if(row.soldTicket_ErrorMessage !== "") {
                setError(row.soldTicket_ErrorMessage);   
            }
            isError = true
        }

        if(isError && isSubmit){
            if(error && error.trim() === "shop_openstatus") {
                setError(null);
            }
            row.soldTicket_ErrorMessage=errMsg;
            row.isChecked=false;
            row.isSelectionAllowed=false;
            props.setRevenueData(row.index, row.contractCode, row);
            if(!isSelectAll) {
                props.setErrorPopUpHandler(errMsg, row.isChangeRequestAllowed ? "cr_submission" : undefined);
            }
            setBorder("soldTicket", row.index, "highlight-field", true);
        } else if(isError) {
            if(error && error.trim() === "shop_openstatus") {
                setError(null);
            }
            row.isChecked=false;
            row.isSelectionAllowed=false;
            props.setRevenueData(row.index, row.contractCode, row);
        } else if(!isSubmit) {
                row.soldTicket_ErrorMessage="";
            if(!isCheckboxSelectionAllowed(row)) {
                row.isSelectionAllowed=true;
            }
            props.setRevenueData(row.index, row.contractCode, row);
            setBorder("soldTicket", row.index, "highlight-field", false);
        }
        return isError
    }

    const clearRemarksErrorMessage = (row) => {
        if(row.remarks_ErrorMessage && row.remarks_ErrorMessage!=="") {
            row.remarks_ErrorMessage="";
        }
    }

    const onSubmitHandler = (ev, row, isChangeRequest) => {
            let isError = false;
            const popupTitle = row.isChangeRequestAllowed ? "cr_submission" : undefined;
            if(checkIfNullOrUndefined(row.revenueAmount.tax_0))
            {
                row.tax_0_ErrorMessage = 'mandatory'
                row.tax_0 = "-1";
                isError = true;
            }
            if(checkIfNullOrUndefined(row.revenueAmount.tax_6))
            {
                row.tax_6_ErrorMessage = 'mandatory'
                row.tax_6 = "-1";
                isError = true;
            }
            if(checkIfNullOrUndefined(row.revenueAmount.tax_12))
            {
                row.tax_12_ErrorMessage = 'mandatory'
                row.tax_12 = "-1";
                isError = true;
            }
            if(checkIfNullOrUndefined(row.revenueAmount.tax_21))
            {
                row.tax_21_ErrorMessage = 'mandatory'
                row.tax_21 = "-1";
                isError = true;
            }
            if(checkIfNullOrUndefined(row.soldTicket))
            {
                row.soldTicket_ErrorMessage = 'mandatory';
                row.soldTicket = null;
                isError = true;
            }

            if (isError === false)
            {
                if(row.isShopOpen === "No") {
                   isError = checkIsShopOpenStatusCorrect(row);
                   if(isError) {
                       setError("shop_openstatus");
                       clearRemarksErrorMessage(row);
                       props.setRevenueData(row.index, row.contractCode, row);
                       return;
                   }
                } else {
                    if(checkAreInValidValuesForShopOpenYes(row, true))
                    {
                        return;
                    }
                }
            }
            
            if(row.isChangeRequestAllowed && row.changeRequest && 
                checkIfNullOrUndefined(row.changeRequest.businessPartnerRemarks)) {
                row.businessPartnerRemarks_ErrorMessage = 'mandatory';
                row.businessPartnerRemarks = "";
                isError = true;
            }

            if(!isNullOrUndefined(row.isShopOpen) && row.isShopOpen_ErrorMessage &&
                row.isShopOpen_ErrorMessage !== "") {
                isError = true;
                row.isShopOpen_ErrorMessage = "";
                clearRemarksErrorMessage(row);
                props.setRevenueData(row.index, row.contractCode, row);
            }

            if(isError === true)
            {
               props.setErrorPopUpHandler("all_mandatory", popupTitle)
               props.setRevenueData(row.index, row.contractCode, row);
            }
            else{
               if ((row.tax_0_ErrorMessage && row.tax_0_ErrorMessage.trim() !== "")||
               (row.tax_6_ErrorMessage && row.tax_6_ErrorMessage.trim() !== "") ||
               (row.tax_12_ErrorMessage && row.tax_12_ErrorMessage.trim() !== "")||
               (row.tax_21_ErrorMessage && row.tax_21_ErrorMessage.trim() !== "")||
               (row.soldTicket_ErrorMessage && row.soldTicket_ErrorMessage.trim() !== ""))
                {
                    isError = true;
                    props.setErrorPopUpHandler("all_mandatory", popupTitle);
                    props.setRevenueData(row.index, row.contractCode, row);
                }

                if(convertToNumber(row.revenueAmount.tax_0) > maxvalue  || convertToNumber(row.revenueAmount.tax_6) > maxvalue ||
                    convertToNumber(row.revenueAmount.tax_12)> maxvalue  || convertToNumber(row.revenueAmount.tax_21)> maxvalue  ||
                    convertToNumber(row.soldTicket) > maxvalue )
                {
                    isError = true;
                    props.setErrorPopUpHandler("all_mandatory", popupTitle);
                    props.setRevenueData(row.index, row.contractCode, row);
                }
            }

            if(row.remarks_ErrorMessage && row.remarks_ErrorMessage !=="") {
                row.remarks_ErrorMessage = "";
                props.setRevenueData(row.index, row.contractCode, row);
            }

            if(isError === false && row.isChangeRequestAllowed && !checkChangeRequestDataChanged(row)) {
                isError = true;
                props.setErrorPopUpHandler("nodata", "cr_submission");
            }

            if(isError === false && props.revenueDate)
            {
                setError(null);
                props.submitRevenue(row.index, row.contractCode, row, props.revenueDate, isChangeRequest);
            }
    }

    const getClassFromFieldErrorMessage = (row, columnName, fieldValueErrorMessage, classname) => {
        let columnNameValue = "";
        if(columnName !== "")
        {
            columnNameValue = columnName !== "soldTicket" ? row.revenueAmount[columnName] : row[columnName];
        }
        return (!isNullOrUndefined(fieldValueErrorMessage) && fieldValueErrorMessage.trim() !== "" ) ||
                (columnNameValue != "" && (isMoreThanMaxValue(columnNameValue) ||
                isInvalidDecimal(columnNameValue))) ? classname + " highlight-field" : classname;
    }

    const isUnSubmittedOrChangeRequest = (row, isCrAllowed, isCrRaised) => {

        return (!row.isSubmitted || 
               (row.isSubmitted && isCrAllowed && row.changeRequest !== undefined && row.changeRequest !==null && !isEmptyObject(row.changeRequest)) ||
               (row.isSubmitted && !isCrAllowed && (!row.changeRequest || isEmptyObject(row.changeRequest))) ||
               isCrRaised);
    }

    const isChangeRequestRaised = (row) => {
        return row.changeRequest && row.changeRequest.changeRequestStatus > 1;
    }

    const withInputBoxFormatter = (row, columnName, isTaxAmountColumn, errorMessageFieldValue, isCrAllowed, isCrRaised) => {
        const isNewOrCr = isUnSubmittedOrChangeRequest(row, isCrAllowed, isCrRaised);
        
        return (
            <OverlayTrigger placement="left" overlay={!row.isMonthlySubmitted ? lockedSubmitTooltip : hiddenTooltip }>
                <div style={{ display: "flex" }}>
                    <NumberFormat
                        id={columnName+"_" + ((row.isSubmitted && !isCrAllowed) ? "Submitted_" : "") + row.index}
                        value={!isTaxAmountColumn ? (isNewOrCr ? row[columnName] : row.changeRequest && row.changeRequest[columnName]) 
                                : (isNewOrCr ? row.revenueAmount[columnName] : row.changeRequest && row.changeRequest.revenueAmount[columnName])}
                        thousandSeparator={"."}
                        decimalSeparator={!isTaxAmountColumn ? false : ","}
                        allowNegative={false}
                        className={ isNewOrCr ?
                                    getClassFromFieldErrorMessage(row, columnName, errorMessageFieldValue, !isTaxAmountColumn ? ((row.isSubmitted && isCrAllowed) ? "Revenue-Soldticket-box cr-fields" : "Revenue-Soldticket-box" ): ((row.isSubmitted && isCrAllowed) ? "Revenue-input-box cr-fields" 
                                    : "Revenue-input-box"))
                                : "Revenue-input-box"}
                        disabled={(row.isSubmitted && !isCrAllowed) || !row.isMonthlySubmitted }
                        onBlur={(ev) => onInputBox_ChangeHandler(ev, row, columnName)}
                    />
                </div>
            </OverlayTrigger>
        )
    }

    const getIsShopOpenOptionsValue = (extraData) => {
        const options = ["Yes", "No"];
        return options.map(opt => {
                    return <option value={opt}>{extraData && languageContext.labels[opt.toLowerCase()]}</option>
        });
    }

    const getRemarksFilterValue = (isShopOpen) =>{
        return props.remarksOptions.filter(x =>x.codeValueCategory.toLowerCase() === isShopOpen.toLowerCase())
    }

    const getRemarksOptionsValues = (row, extraData, isNewOrCr) => {
        const options = isNewOrCr ? row.remarksOptionValues : row.crRemarksOptionValues;
        return options && options.map(item=>{
            return <option value={item.codeValueId}>{extraData && languageContext.labels[item.codeValue]}</option>
        })
    }

    const withShopOpenDropdownFormatter = (row, extraData, isCrAllowed, isCrRaised) => {
        const isNewOrCr = isUnSubmittedOrChangeRequest(row, isCrAllowed, isCrRaised);

        return (
            <div style={{ display: "flex" }}>
                <select value={isNewOrCr ? row.isShopOpen : row.changeRequest && row.changeRequest.isShopOpen} id={((row.isSubmitted && !isCrAllowed) ? "isShopOpen_Submitted_" : "isShopOpen_")+row.index}
                            title="Shop open selection"
                            className={isNewOrCr ? 
                                    getClassFromFieldErrorMessage(row, "", row.isShopOpen_ErrorMessage,
                                    (!row.isMonthlySubmitted || (row.isSubmitted && !isCrAllowed)) ? 
                                    "Revenue-select-box dropdown-disabled" : (row.isSubmitted && isCrAllowed) ? 
                                    "Revenue-select-box cr-fields" : "Revenue-select-box")
                                : (row.isSubmitted) ? "Revenue-select-box dropdown-disabled" : "Revenue-select-box"}
                            disabled={(row.isSubmitted && !isCrAllowed) || !row.isMonthlySubmitted}
                            onChange={(ev) => onShopOpenDropdown_ChangeHandler(ev, row, extraData, isNewOrCr)}
                >
                    {getIsShopOpenOptionsValue(extraData)}
                </select>
            </div>
        )
    }

    const remarksTooltip = (remarksCode) => (
        <Tooltip>{languageContext && languageContext.labels[remarksCode]}</Tooltip>
    );

    const withRemarksDropdownFormatter = (row, extraData, isCrAllowed, isCrRaised) => {
        const isNewOrCr = isUnSubmittedOrChangeRequest(row, isCrAllowed, isCrRaised);
        return (
            //    <div style={{ display: "flex" }}>
                <OverlayTrigger placement="right" overlay={remarksTooltip(isNewOrCr ? row.remarksCode : row.changeRequest && row.changeRequest.remarksCode)}>
                    <div style={{ display: "flex" }}>
                        <select value={isNewOrCr ? row.remarksId : row.changeRequest && row.changeRequest.remarksId}
                                id={((row.isSubmitted && !isCrAllowed) ? "remarks_Submitted_" : "remarks_")+row.index}
                                className={isNewOrCr ? 
                                    getClassFromFieldErrorMessage(row, "", row.remarks_ErrorMessage,
                                    (!row.isMonthlySubmitted || (row.isSubmitted && !isCrAllowed)) ?
                                    "Remarks-select-box-revenue dropdown-disabled" : (row.isSubmitted && isCrAllowed) ?
                                    "Remarks-select-box-revenue cr-fields" : "Remarks-select-box-revenue")
                                : (row.isSubmitted) ? "Remarks-select-box-revenue dropdown-disabled" : "Remarks-select-box-revenue"}
                                disabled={(row.isSubmitted && !isCrAllowed) || !row.isMonthlySubmitted}
                                onChange={(ev) => onRemarksDropdown_ChangeHandler(ev, row)}
                        >
                            {getRemarksOptionsValues(row, extraData, isNewOrCr)}
                        </select>
                    </div>
                </OverlayTrigger>
            // </div>
        )
    }

    const columns = [
        {
            dataField: 'businessPartnerCode',
            hidden: true
        },
        {
            dataField: 'revenueDate',
            hidden: true
        },
        {
            dataField: 'revenueId',
            hidden: true
        },
        {
            dataField: 'contractId',
            hidden: true
        },
        {
            dataField: 'contractCode',
            text: <LabelText tid="contractcode" />,
            classes: "Contractcode",
            headerClasses: "Contractcode-header",
            editable: false
        },
        {
            dataField: 'isShopOpen',
            text: <LabelText tid="Shop_Open" />,
            editable: false,
            classes: "Shopopen",
            headerClasses: "Shopopen-header",
            formatExtraData: languageContext && languageContext.language.id,
            formatter: (cell, row, rowIndex, extraData) => withShopOpenDropdownFormatter(row, extraData, false, isChangeRequestRaised(row))
        },
        {
            dataField: 'remarksId',
            text: <LabelText tid="remarks" />,
            editable: false,
            classes: "Remarks",
            headerClasses: "Remarks-header",
            formatExtraData: languageContext && languageContext.language.id,
            formatter: (cell, row, rowIndex, extraData) => withRemarksDropdownFormatter(row, extraData, false, isChangeRequestRaised(row))
        },
        {
            dataField: 'revenueAmount.tax_0',
            text: <LabelText tid="Tax_0" />,
            editable: false,
            headerClasses: "Vat-header",
            formatter: (cell, row, rowIndex) => withInputBoxFormatter(row, "tax_0", true, row.tax_0_ErrorMessage, false, isChangeRequestRaised(row))
        },
        {
            dataField: 'revenueAmount.tax_6',
            text: <LabelText tid="Tax_6" />,
            editable: false,
            headerClasses: "Vat-header",
            formatter: (cell, row, rowIndex) => withInputBoxFormatter(row, "tax_6", true, row.tax_6_ErrorMessage, false, isChangeRequestRaised(row))
        },
        {
            dataField: 'revenueAmount.tax_12',
            text: <LabelText tid="Tax_12" />,
            editable: false,
            headerClasses: "Vat-header",
            formatter: (cell, row, rowIndex) => withInputBoxFormatter(row, "tax_12", true, row.tax_12_ErrorMessage, false, isChangeRequestRaised(row))
        },
        {
            dataField: 'revenueAmount.tax_21',
            text: <LabelText tid="Tax_21" />,
            editable: false,
            headerClasses: "Vat-header",
            formatter: (cell, row, rowIndex) => withInputBoxFormatter(row, "tax_21", true, row.tax_21_ErrorMessage, false, isChangeRequestRaised(row))
        },
        {
            dataField: 'soldTicket',
            text: <LabelText tid="Sold_Ticket" />,
            editable: false,
            headerClasses: "Soldtickets-header",
            formatter: (cell, row, rowIndex) => withInputBoxFormatter(row, "soldTicket", false, row.soldTicket_ErrorMessage, false, isChangeRequestRaised(row))
        },
        {
            dataField: 'isSubmitted',
            text: <LabelText tid="status" />,
            editable: false,
            headerClasses: "Submit-header",
            headerFormatter: selectAllFormatter,
            formatExtraData: props.revenue,
            formatter: (cell, row, rowIndex, extraData) => {
                if (row.isSubmitted || (row.isFutureDateAndShopOpenYes && row.isMonthlySubmitted)){
                    return (
                        <OverlayTrigger placement="left" overlay={row.isFutureDateAndShopOpenYes ? futureDateSubmitTooltip: hiddenTooltip }>
                            <div style={{ margin: "0vw 0vw 0vw 1.7vw", width : "5.1vw", float: "left" }}>
                                <Button variant="secondary" 
                                    title={row.isSubmitted ? "Submitted button": "Submit button"}
                                    size="sm"
                                    className="Submit-btn Submitted-btn-bgcolor"
                                    onClick={(ev)=> ev.preventDefault()}
                                ><LabelText tid={row.isFutureDateAndShopOpenYes ? "submit" : "submitted"} /></Button>
                            </div>
                        </OverlayTrigger>
                    );
                }
                else{
                    return (
                        <div style={{ width: "7vw" }}>
                            <div style={{ float: "left" }}>
                                {!row.isMonthlySubmitted ? <div className="fa-lock" /> : selectCheckboxFormatter(row)}
                            </div>  
                            <OverlayTrigger placement="left" overlay={!row.isMonthlySubmitted ? lockedSubmitTooltip: !row.isChecked ? submitTooltip : hiddenTooltip}>
                                <div style={{ width : "5.1vw", float: "right"}}>
                                    {   !row.isChecked ?
                                        <Button variant="primary" title= "Submit button" size="sm"
                                        className= {!row.isMonthlySubmitted ? "Submit-btn Submit-btn-locked":
                                        "Submit-btn Submit-btn-bgcolor"}
                                        onClick={(ev) => row.isMonthlySubmitted ? onSubmitHandler(ev, row) : undefined}>
                                            <LabelText tid="submit" />
                                        </Button>
                                    :   <FontAwesomeIcon className={"fa-select-checkbox"} 
                                        icon={faAngleDoubleDown} />
                                    }
                                </div>
                            </OverlayTrigger>
                        </div>
                    );
                }
            }
        }
    ];

    let data = revenueData && revenueData.length > 0 ? revenueData : [];

    const tableRowStyle = (row, rowIndex) => {
        row.index = rowIndex;
        const style = {};
        style.lineHeight = "8vh";
        if (rowIndex % 2 === 0)
            style.backgroundColor = '#FFFFFF';
        else
            style.backgroundColor = '#EFF4F9';

        return style;
    }

    const getChangeRequestDataByContractId = (revData, contractId, columnName) => {
        if(revData.some(d=>d.isSubmitted && d.changeRequest && 
            d.contractId === contractId)) {
            return revData.filter(d=>d.isSubmitted && d.changeRequest && 
                        d.contractId === contractId)
                        .map(row => row.changeRequest[columnName]);
        } else if(revData.some(d=>!d.isSubmitted && !d.isMonthlySubmitted && !d.isUnblockChangeRequestAllowed
            && d.unblockChangeRequest && d.unblockChangeRequest.changeRequestStatus === changeRequestStatuses.Inprogress.id
            && d.contractId === contractId)) {
            return revData.filter(d=>!d.isSubmitted && !d.isMonthlySubmitted && !d.isUnblockChangeRequestAllowed
                                    && d.unblockChangeRequest && d.unblockChangeRequest.changeRequestStatus === changeRequestStatuses.Inprogress.id
                                    && d.contractId === contractId)
                            .map(row => row.unblockChangeRequest[columnName]);
        }
    }

    const getSelectedUnblockRequestData = (revData, contractId) => {
        if(revData.some(d=>!d.isSubmitted && !d.isMonthlySubmitted && d.isUnblockChangeRequestAllowed
            && d.unblockChangeRequest && d.unblockChangeRequest.changeRequestStatus === changeRequestStatuses.Unsubmitted.id
            && d.contractId === contractId)) {
            return revData.find(d=>!d.isSubmitted && !d.isMonthlySubmitted && d.isUnblockChangeRequestAllowed
                                    && d.unblockChangeRequest && d.unblockChangeRequest.changeRequestStatus === changeRequestStatuses.Unsubmitted.id
                                    && d.contractId === contractId)
        }
    }

    const renderActionIcon = (expandable, rowKey, expanded) => {
        let actionIcon = <FontAwesomeIcon className={"fa-cr-action"} icon={faSyncAlt} style={{color: "gray"}} />;
        const crNumber = getChangeRequestDataByContractId(revenueData, rowKey, "changeRequestNumber");
        const row = getSelectedUnblockRequestData(revenueData, rowKey);
        if (expandable) {
            actionIcon = <CustomOverlayTrigger placement="left" tooltip={changeRequestTooltip("request_change")}>
                            <FontAwesomeIcon className={"fa-cr-action"}  icon={faSyncAlt}
                            style={!expanded ? {color: "green", pointerEvents: "all"}: {color: "gray"}}
                            role={!expanded ? "button" : undefined} tabIndex={!expanded ? 0 : -1}
                            onKeyDown={(e)=>{ 
                                                if (expandable && e.key === "Enter") {
                                                    handleOnKeyDownExpand(expanded, rowKey)
                                                }
                                            }
                            }
                         />
                        </CustomOverlayTrigger>   ;
        }
        else if(row && lockedContractList && lockedContractList.length > 0 && lockedContractList.some(d=>d === rowKey)) {
           actionIcon = <CustomOverlayTrigger placement="left" tooltip={changeRequestTooltip("unblock_request", crNumber && crNumber[0])}>
                            <div className="fa-cr-unblock" role= {"button"} tabIndex={0} 
                                onClick={(ev) => row && props.handlerOnUnblockRequestIconClick(row, row.index)}
                                onKeyDown={(ev)=>{ if (ev.key === "Enter") {
                                    row && props.handlerOnUnblockRequestIconClick(row, row.index)
                                }}} 
                            />
                        </CustomOverlayTrigger>;
        }  
        else if((inprocessCRList && inprocessCRList.length > 0 && inprocessCRList.some(d=>d === rowKey)) ||
                (inprocessUnlockCRList && inprocessUnlockCRList.length > 0 && inprocessUnlockCRList.some(d=>d === rowKey)))
         {
            actionIcon = <CustomOverlayTrigger placement="left" 
                            tooltip={changeRequestTooltip("cr_pending", crNumber && crNumber[0])}>
                            <FontAwesomeIcon className={"fa-cr-inprogress"} icon={faHourglassHalf} />
                        </CustomOverlayTrigger>;
        } else if(approveCRList && approveCRList.length > 0 && approveCRList.some(d=>d === rowKey)) {
            actionIcon = <CustomOverlayTrigger placement="left" tooltip={changeRequestTooltip("cr_approved", crNumber && crNumber[0])}>
                            <FontAwesomeIcon className={"fa-cr-approve"} icon={faCheckSquare} />
                        </CustomOverlayTrigger>;
        } else if(declineCRList && declineCRList.length > 0 && declineCRList.some(d=>d === rowKey)) {
            actionIcon = <CustomOverlayTrigger placement="left" tooltip={changeRequestTooltip("cr_declined", crNumber && crNumber[0])}>
                            <FontAwesomeIcon className={"fa-cr-decline"} icon={faWindowClose} />
                        </CustomOverlayTrigger>;
                    }

        return (
        actionIcon
        );
    }

    const checkErrorMessage = (rowindex) => {
        let fieldLevelError = "";
        revenueData.map((d, index) => {
            if(index !== rowindex) {

                fieldLevelError = checkFieldValidation(d, fieldLevelError);

                if(fieldLevelError === "" && d.remarks_ErrorMessage && d.remarks_ErrorMessage.trim()!==""){
                    fieldLevelError = d.remarks_ErrorMessage;
                } else if(fieldLevelError === "" && d.businessPartnerRemarks_ErrorMessage && d.businessPartnerRemarks_ErrorMessage.trim()!==""){
                    fieldLevelError = d.businessPartnerRemarks_ErrorMessage;
                }
                fieldLevelError = isInvalidValueExistsInRow(d, "fieldexceeding") ? "fieldexceeding" : fieldLevelError;
            }
        });

        setError(fieldLevelError);
    }

    const handlerOnCancel = (isExpand, rowKey, row) => {
        props.cancelChangeRequestHandler(row.index, rowKey, row);
        checkErrorMessage(row.index);
        setExpandedRowId(isExpand, rowKey);
    }

    const renderCrButtonIcon =  (row) => {
        return (
        <div style={{ display: "flex", margin: "0vw 0vw 0vw 1.3vw", width : "5.1vw", float: "left" }}>
            <CustomOverlayTrigger placement="left" tooltip={changeRequestTooltip("send_change")}>            
                <div style={{display: "inline-flex", margin: "0.2vw 0.4vw", verticalAlign: "middle"}} >
                    <div className="cr-submit-icon" role= {"button"} tabIndex={0} 
                        onClick={(ev) => onSubmitHandler(ev, row, true)}
                        onKeyDown={(ev)=>{ if (ev.key === "Enter") onSubmitHandler(ev, row, true)}} 
                    />
                </div>
            </CustomOverlayTrigger>
            <CustomOverlayTrigger placement="right" tooltip={changeRequestTooltip("cancel")}>
                <div style={{display: "inline-flex", margin: "0vw 0.4vw", verticalAlign: "middle"}} >
                    <FontAwesomeIcon className={"fa-cr-cancel"} icon={faTimes}
                    role= {"button"} tabIndex={0} onClick={(e)=>handlerOnCancel(false, row.contractId, row)}
                    onKeyDown={(e)=>{ if (e.key === "Enter") handlerOnCancel(false, row.contractId, row)}} />
                </div>
            </CustomOverlayTrigger>
        </div>);
    }

    const expandColumnHandler =  (expanded, rowKey, expandable) => {
        return (
        <div style={{pointerEvents: "none"}}>
                {renderActionIcon(expandable, rowKey, expanded)}
        </div>);
    }

    const handleOnKeyDownExpand = (isExpand, rowKey) => {
        if(isNullOrUndefined(expendedRowList)) {
            setExpendedRowList([]);
        }

        setExpandedRowId(expendedRowList.length === 0, rowKey);
    }

    const setExpandedRowId = (isExpand, rowKey) => {
        if (isExpand) {
            setExpendedRowList(prevArray => [...prevArray, rowKey]);
        } 
        else {
            setExpendedRowList(expendedRowList.filter(( id ) => id !== rowKey));
        }
    }

    const handleOnExpand = (row, isExpand) => {
        setExpandedRowId(isExpand, row.contractId);
    }

    const crRemarksChangeHandler = (e, row) => {
        row.changeRequest.businessPartnerRemarks = e.target.value;
        if(e.target.value !== "") {
            row.businessPartnerRemarks_ErrorMessage = ""; 
        }
        props.setRevenueData(row.index, row.contractCode, row);
    }

    const getExpendableRowData = (row) => {
        return (
            <table className="Revenue-inner-table">
                <thead style={{ display: "table-header-group", visibility: "collapse", padding: "0" }}>
                    <tr className="Revenue-datatable-header" style={{ lineHeight:"7vh", color: row.index % 2 === 0 ? '#eff4f9'
                            : '#ffffff' }}>
                        <th className="Contractcode-header"><LabelText tid="contractcode" /></th>
                        <th className="Shopopen-header"><LabelText tid="Shop_Open" /></th>
                        <th className="Remarks-header"><LabelText tid="remarks" /></th>
                        <th style={{width:"12%"}}><LabelText tid="Tax_0" /></th>
                        <th style={{width:"12%"}}><LabelText tid="Tax_6" /></th>
                        <th style={{width:"12%"}}><LabelText tid="Tax_12" /></th>
                        <th style={{width:"11.95%"}}><LabelText tid="Tax_21" /></th>
                        <th className="Soldtickets-header"><LabelText tid="Sold_Ticket" /></th>
                        <th className="Submit-header"><LabelText tid="status" /></th>
                        <th className="expand-cell-header"><LabelText tid="actions" /></th>
                    </tr>
                </thead>
                <tbody style={{
                    display: "table-row-group",
                    verticalAlign: "middle",
                    borderColor: "inherit"
                }}>
                    {<>
                            <tr key={row.contractId} style={{
                                display: "table-row",
                                verticalAlign: "inherit",
                                borderColor: "inherit",
                                lineHeight:"7vh",
                                backgroundColor: row.index % 2 !== 0 ? '#eff4f9' : '#ffffff'
                            }}
                            >
                                <td/>
                                <td className="Shopopen">{withShopOpenDropdownFormatter(row,
                                                    languageContext && languageContext.language.id,
                                                    row.isChangeRequestAllowed)}</td>
                                <td className="Remarks">{withRemarksDropdownFormatter(row,
                                                    languageContext && languageContext.language.id,
                                                    row.isChangeRequestAllowed)}</td>
                                <td >{withInputBoxFormatter(row, "tax_0", true, row.tax_0_ErrorMessage, row.isChangeRequestAllowed)}</td>
                                <td >{withInputBoxFormatter(row, "tax_6", true, row.tax_6_ErrorMessage, row.isChangeRequestAllowed)}</td>
                                <td >{withInputBoxFormatter(row, "tax_12", true, row.tax_12_ErrorMessage, row.isChangeRequestAllowed)}</td>
                                <td >{withInputBoxFormatter(row, "tax_21", true, row.tax_21_ErrorMessage, row.isChangeRequestAllowed)}</td>
                                <td >{withInputBoxFormatter(row, "soldTicket", false, row.soldTicket_ErrorMessage, row.isChangeRequestAllowed)}</td>
                                <td><div style={{ margin: "0vw 0vw 0vw 1.3vw", width : "4.95vw", float: "left" }}/></td>
                                <td><div/></td>
                            </tr>
                            <tr key={row.contractId} style={{
                                display: "table-row",
                                verticalAlign: "inherit",
                                borderColor: "inherit",
                                lineHeight:"7vh",
                                backgroundColor: row.index % 2 !== 0 ? '#eff4f9' : '#ffffff'
                            }}>
                                <td colSpan="2" className="inner-remarks"><LabelText tid="remarks_business_partner" />(*)</td>
                                <td  colSpan="6">
                                    <input type="textarea" maxLength={config.maxCharLengthOfRemarks} 
                                    placeholder={languageContext && languageContext.labels["allowed_chars"]}
                                    className={getClassFromFieldErrorMessage(row, "", row.businessPartnerRemarks_ErrorMessage, "form-control cr-remarks")}
                                    value={row.changeRequest && row.changeRequest.businessPartnerRemarks}
                                    onChange={(e)=>crRemarksChangeHandler(e, row)} />
                                    {
                                        row.changeRequest.businessPartnerRemarks && row.changeRequest.businessPartnerRemarks.length > 0 ?
                                        <RemainingCharacters enteredCharsLength={row.changeRequest.businessPartnerRemarks.length} />
                                        : undefined
                                    }
                                </td>
                                <td>{renderCrButtonIcon(row)}</td>
                                <td>&nbsp;</td>
                            </tr>
                        </>
                    }
                </tbody>
            </table>
        )
    }

    const expandRow = {
        renderer: (row) => getExpendableRowData(row),
        expandHeaderColumnRenderer: ({ isAnyExpands }) => {
            return <span><LabelText tid={"actions"} /></span>;
        },
        expandColumnPosition: 'right',
        expandColumnRenderer: ({ expanded, rowKey, expandable }) => expandColumnHandler(expanded, rowKey, expandable),
        expanded: expendedRowList,
        onExpand: handleOnExpand,
        showExpandColumn: true,
        expandByColumnOnly: true,
        onlyOneExpanding: true,
        nonExpandable: data.length > 0 && data.reduce((arr, item, index) => {
                if (!item.isSubmitted || (item.isSubmitted && !item.isChangeRequestAllowed && (!item.changeRequest || isEmptyObject(item.changeRequest)))
                    || (item.isSubmitted && !item.isChangeRequestAllowed && 
                    ((item.changeRequest && item.changeRequest.changeRequestStatus === changeRequestStatuses.Inprogress.id) 
                    || isChangeRequestRaised(item)))) { arr.push(item.contractId) }
                    return arr;
                }
        , []),
    }

    const isSubmitSelectionAllowed = props.revenue && props.revenue.length > 0 && props.revenue.some(d=>!d.isSubmitted && d.isMonthlySubmitted && d.isSelectionAllowed && d.isChecked);

    return (
        <div>
            <Container>
            <Row>
                <BootstrapTable
                    keyField='contractId'
                    data={data}
                    columns={columns}
                    noDataIndication={(props.dataLoading || (props.revenue && props.revenue.length > 0)) ? <LabelText tid="data_loading" /> 
                                    : <LabelText tid="Noactivecontract" />}
                    bordered
                    rowStyle={tableRowStyle}
                    classes={"Revenue-datatable scroller"}
                    headerClasses={"Revenue-datatable-header"}
                    expandRow={expandRow}
                    cellEdit={
                        cellEditFactory({
                            mode: 'click',
                            blurToSave: true
                        })
                }
            />
            </Row>
            <Row>
                <SubmitSelectionFooter isSubmitSelectionAllowed={isSubmitSelectionAllowed}
                    showSelectionFooter={isHeaderSelectionAllow(props.revenue && props.revenue.length > 0 ? props.revenue : [])}
                    selectedData={props.revenue && props.revenue.length > 0 ? props.revenue.filter(
                                    d=>!d.isSubmitted && d.isMonthlySubmitted && d.isSelectionAllowed && d.isChecked
                                ) : []}
                    selectedDate={props.revenueDate}
                    submitSelectedHandler={props.submitSelectedRevenueHandler} 
                    selectedCount={isSubmitSelectionAllowed ? 
                                    props.revenue.filter(d=>!d.isSubmitted && d.isMonthlySubmitted && d.isSelectionAllowed && d.isChecked).length 
                                    : 0
                                }
                />
            </Row>
            <Row>
            {
                <div style={{ width: '100%'}}>
                    {
                        <div className="Error-container-Footer">
                            { error && error.trim() !== "" ? <>
                            <div className = "Error-icon"/>
                            <div className="Errormsg">
                                <LabelText tid={ error } />
                            </div>
                            </>
                            : rawDateError && rawDateError.trim() !== "" ? <>
                                <div className="Error-icon" />
                                <div className="Errormsg">
                                    <LabelText tid={rawDateError} />
                                </div>
                            </>
                            : undefined}
                        </div>
                    }
                </div>
            }
            </Row></Container>
        </div>
    );
}
